<template>
  <r-toggle-card
    title="Направление"
    :is-open="config.enabled"
    @toggle="toggleProperty"
  />
</template>

<script>
export default {
  props: {
    config: {
      type: Object
    }
  },
  methods: {
    toggleProperty(value) {
      this.$emit("toggle", value);
    }
  }
};
</script>

<style></style>
